import React, { useEffect, useState } from "react";
import "../styles/GiftAnimationOverlay.css";

/*
  GiftAnimationOverlay
  - Affiche une animation temporaire
  - Petit cadeau = confettis / glow
*/

function GiftAnimationOverlay({ animation }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!animation) return;

    setVisible(true);

    const timer = setTimeout(() => {
      setVisible(false);
    }, 1200); // durée animation

    return () => clearTimeout(timer);
  }, [animation]);

  if (!visible || !animation) return null;

  return (
    <div className="gift-animation-overlay">
      <div className="gift-animation-card">
        <img
          src={animation.image}
          alt={animation.name}
          className="gift-animation-image"
        />
        <div className="gift-animation-text">
          🎁 {animation.name}
        </div>

        {/* confettis */}
        <div className="confetti confetti-1" />
        <div className="confetti confetti-2" />
        <div className="confetti confetti-3" />
        <div className="confetti confetti-4" />
        <div className="confetti confetti-5" />
      </div>
    </div>
  );
}

export default GiftAnimationOverlay;
